import { FeatureIslandMainWithCategoryWrapper } from "@/components/features/_layouts";

import { QuestionReservationPlanSettings as _QuestionReservationPlanSettings } from "./plan/root";

import type { HotelPolicyCategoriesAndManagerStore } from "../../../../store/categories";

type Props = {
	reservationPlanSettings: HotelPolicyCategoriesAndManagerStore["reservationPlanSettings"];
};

export const QuestionReservationPlanSettings = ({ reservationPlanSettings }: Props) => {
	return (
		<FeatureIslandMainWithCategoryWrapper categoryStore={reservationPlanSettings}>
			<_QuestionReservationPlanSettings />
		</FeatureIslandMainWithCategoryWrapper>
	);
};

QuestionReservationPlanSettings.displayName = "QuestionReservationPlanSettings";
